import { render, staticRenderFns } from "./SaleTransaction.vue?vue&type=template&id=03b8a9c5&scoped=true"
import script from "./SaleTransaction.vue?vue&type=script&lang=js"
export * from "./SaleTransaction.vue?vue&type=script&lang=js"
import style0 from "./SaleTransaction.vue?vue&type=style&index=0&id=03b8a9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b8a9c5",
  null
  
)

export default component.exports